import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NewUserGuard } from './core/guards/new-user.guard';
import { RoleGuard } from './core/guards/role.guard';
import { LayoutComponent } from './layout/layout.component';
import { ForgotPasswordComponent } from './login/containers/forgot-password/forgot-password.component';
import { LoginComponent } from './login/containers/login/login.component';
import { ModalRolesComponent } from './login/containers/modal-roles/modal-roles.component';
import { UpdatePasswordComponent } from './login/containers/update-password/update-password.component';
import { ViewProfileComponent } from './login/containers/view-profile/view-profile.component';
import { AuthGuard } from './login/guards/auth.guard';
import { AutoLoginResolverService } from './login/services/auto-login-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'view-profile', component: ViewProfileComponent },
      { path: 'roles', component: ModalRolesComponent, canLoad: [AuthGuard] },
      {
        path: 'update-password',
        component: UpdatePasswordComponent,
        resolve: {
          auth: AutoLoginResolverService
        }
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then(mod => mod.HomeModule),
        canLoad: [AuthGuard, NewUserGuard],
        canActivate: [RoleGuard]
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },
  {
    path: 'not-found',
    loadChildren: () =>
      import('./not-found/not-found.module').then(m => m.NotFoundModule)
  },
  { path: '**', redirectTo: 'not-found', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
